import React, { FC, useEffect, useRef, useState } from 'react';

import cx from 'classnames';

import Loader from '../atoms/Loader';

export interface IWithLoaderProps extends React.HTMLAttributes<HTMLSpanElement> {
  isLoading?: boolean;
  force?: boolean;
  loaderClassName?: string;
}

/**
 * @param isLoading
 * @param force
 * @param loaderClassName
 * @param children
 * @param rest
 * @constructor
 * @deprecated use NewLoader and if needed special handling - implement locally
 */
const WithLoader: FC<IWithLoaderProps> = ({
  isLoading = true,
  force = false,
  loaderClassName,
  children,
  ...rest
}) => {
  const contentRef = useRef(null);
  const [initialLoad, setInitialLoad] = useState(true);

  useEffect(() => {
    if (!isLoading) {
      setInitialLoad(false);
    }
  }, [isLoading, setInitialLoad]);

  const size =
    isLoading && contentRef?.current?.offsetHeight
      ? {
          minHeight: `${contentRef.current.offsetHeight}px`,
          minWidth: `${contentRef.current.offsetWidth}px`,
        }
      : {};

  return (
    <span ref={contentRef} {...rest}>
      {isLoading && (
        <div className={cx('inline', loaderClassName)}>
          <div className="inline-block" style={{ ...size }} />
          <Loader />
        </div>
      )}
      {(!isLoading || (!initialLoad && !force)) && children}
    </span>
  );
};

export default WithLoader;
